export function isElementHidden(element) {
    return element.classList.contains('ng-hide');
}
